// Text Repeat Tool — repeat a piece of text N times with separators.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const textRepeatTool: Tool = {
  id: "text-repeat",
  name: () => m.tr_tool_name(),
  description: () => m.tr_tool_description(),
  icon: "🔁",
  basePath: "/text-repeat",
  status: "stable",
  tags: ["text", "repeat", "generator", "developer"],
  pages: [
    {
      name: () => m.tr_nav_main(),
      path: "/text-repeat",
      description: () => m.tr_nav_main_desc(),
      icon: "🔁",
    },
  ],
};
